import { Tooltip, Typography } from '@mui/material';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { type FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './DashboardHeader.module.scss';

interface Props {
  dashboard?: Dashboard;
}

const defaultProps = { dashboard: undefined };

const DashboardHeader: FC<Props> = ({ dashboard }) => (
  <>
    {dashboard && (
      <div className={styles.content}>
        <Typography variant="h5">
          <span className={styles.content__title}>
            {dashboard.name}
            {dashboard.isCertified ? (
              <Tooltip title="Certified">
                <span className={styles.content__certified}>
                  <Icon iconId="certified" />
                </span>
              </Tooltip>
            ) : undefined}
          </span>
        </Typography>
        <span className={styles.content__area}>
          <Link to={`/areas/${dashboard.area.id}/${dashboard.area.subareaId}`}>
            <Typography variant="subtitle1">
              {[
                dashboard.area.name,
                dashboard.area.subareaName,
                dashboard.area.subsubareaName,
              ].join(' - ')}
            </Typography>
          </Link>
        </span>
      </div>
    )}
  </>
);

DashboardHeader.defaultProps = defaultProps;

export default DashboardHeader;
